import React from 'react';

import { AccountSideBarNav } from '@fly/features/account';

import { useUserNavItems } from '../../hooks/useUserNavItems';
import { SideBarNav } from '../SideBarNav/SideBarNav';

interface SidebarContainerProps {
  isAccountRoute: boolean;
}

export const SidebarContainer = React.memo<SidebarContainerProps>(
  ({ isAccountRoute }) => {
    const userNavItems = useUserNavItems();

    if (isAccountRoute) {
      return <AccountSideBarNav items={userNavItems} />;
    }

    return <SideBarNav />;
  }
);

SidebarContainer.displayName = 'SidebarContainer';
